<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container ">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center mt-4" [ngClass]="{'page-title': useRebrandedLayout }">
          Update your {{ address.addressType ===  userAddressType.Main ? 'main' : 'secondary' }} address
        </h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 text-center mt-5 mb-3">
        <h5 [ngClass]="{'page-title': useRebrandedLayout }">
          To change your {{ address.addressType ===  userAddressType.Main ? 'main' : 'secondary' }} address, please fill in the fields below:
        </h5>
      </div>
    </div>

    <div class="row mb-5">
      <div [ngClass]="useRebrandedLayout ? 'mx-auto mb-3 col-md-6' : 'col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3'">
        <app-address-form
          [address]="address"
          [userContact]="user.contact"
          [showLoader]="loading"
          (save)="onSave()">
        </app-address-form>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a *ngIf="!redirectParams" [routerLink]="['/account']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
        </a>
        <a
          *ngIf="redirectParams"
          [routerLink]="redirectParams.l"
          [queryParams]="redirectParams.q"
          [fragment]="redirectParams.f">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back
        </a>
      </div>
    </div>
  </div>
</div>
